module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('claims-dashboard-icons'), _vm._v(" "), _c('div', {
    staticClass: "o-date-stepped-inputs__section-content u-d-flex a-form-inputs"
  }, [_c('div', {
    staticClass: "o-date-stepped-inputs__section-content-header"
  }, [_c('h2', [_vm._v("Period " + _vm._s(_vm.index + 1) + " (" + _vm._s(_vm.period.startOfPeriod) + " - " + _vm._s(_vm.period.endOfPeriod) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    on: {
      "click": _vm.toggleFirst
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "period-toggle",
      "tooltip-text": "To toggle the period between minimized and maximized just select this icon.",
      "side": "left",
      "text-width": "200",
      "icon-type": "toggle",
      "icon-colour": "m-icon--dark"
    }
  })], 1), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.removePeriod()
      }
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "period-delete",
      "tooltip-text": "To delete the period just select this icon. This will delete all data held within the period.",
      "side": "left",
      "text-width": "200",
      "icon-type": "delete",
      "icon-colour": "m-icon--dark"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-wrap a-form-inputs u-full-width"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    From\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "start_of_period",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:start_of_period.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "start_of_period",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.index === 0
    },
    model: {
      value: (_vm.period.startOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.period, "startOfPeriod", $$v)
      },
      expression: "period.startOfPeriod"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('start_of_period')
    }
  }, [_vm._v("\n                        The start of period date must be a valid date (DD/MM/YYYY).\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    To\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "end_of_period",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:end_of_period.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "end_of_period",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": function($event) {
        return _vm.updatePostInjuryIncomePeriod()
      }
    },
    model: {
      value: (_vm.period.endOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.period, "endOfPeriod", $$v)
      },
      expression: "period.endOfPeriod"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('end_of_period')
    }
  }, [_vm._v("\n                        The end of period date must be a valid date (DD/MM/YYYY).\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.afterEndOfPeriodRule
    }
  }, [_vm._v("\n                        The end of period date must be before the date of assumed settlement (" + _vm._s(_vm.getClaimInfo('dateOfAssumedSettlement')) + ").\n                    ")])], 1)], 1), _vm._v(" "), (!_vm.toggleOne) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Employment Status\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employmentType",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.employmentType),
      expression: "period.employmentType"
    }, {
      name: "field-control",
      rawName: "v-field-control:employmentType.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "employmentType",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "employmentType",
      "id": "employmentType",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.period, "employmentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePostInjuryIncomePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "part_employed"
    }
  }, [_vm._v("Part-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "absence"
    }
  }, [_vm._v("Absent")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('employmentType') || _vm.period.employmentType === null || _vm.period.employmentType === ''
    }
  }, [_vm._v("\n                        Employment status is required\n                    ")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.toggleOne && _vm.period.employmentType !== '' && _vm.period.employmentType !== 'absence') ? _c('div', {
    staticClass: "flex-grid__item--third u-padding-l-0"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    New Employment Income\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employmentIncome",
      "table-control": true,
      "icon-space": false,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.period.employmentIncome),
      expression: "period.employmentIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:employmentIncome.required",
      value: ({
        type: 'number'
      }),
      expression: "{type:'number'}",
      arg: "employmentIncome",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.period.employmentIncome)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.period, "employmentIncome", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updatePostInjuryIncomePeriod()
      }],
      "focus": function($event) {
        _vm.period.employmentIncome = _vm.period.employmentIncome || ''
      },
      "blur": [function($event) {
        _vm.period.employmentIncome = _vm.period.employmentIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('employmentIncome') || _vm.period.employmentIncome < 1
    }
  }, [_vm._v("\n                        Employment Income must be greater than £0\n                    ")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.toggleOne && _vm.period.employmentType !== '' && _vm.period.employmentType !== 'absence') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Net/Gross\n                    ")]), _vm._v(" "), (_vm.disableNetGross) ? _c('icon-tooltip', {
    attrs: {
      "tooltip-name": "net-gross",
      "tooltip-text": "ASHE Data are gross median figures. Therefore the Net function has been disabled. To re-enable edit the employment income figure.",
      "side": "right",
      "text-width": "200",
      "icon-type": "info",
      "icon-colour": "m-icon--dark"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.employmentNetGross),
      expression: "period.employmentNetGross"
    }],
    attrs: {
      "name": "",
      "disabled": _vm.disableNetGross
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.period, "employmentNetGross", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePostInjuryIncomePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.toggleOne && _vm.period.employmentType !== '' && _vm.period.employmentType !== 'absence') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Total Annual Net Income\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true,
      "icon-space": false,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.period.totalNetIncome
    }
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.toggleOne) ? _c('div', {
    staticClass: "u-margin-top-20 u-full-width"
  }, [(_vm.period.employmentType !== '' && _vm.period.employmentType !== 'absence') ? _c('button', {
    staticClass: "a-button a-button--small u-margin-right-10",
    on: {
      "click": function($event) {
        return _vm.selectSalary(null)
      }
    }
  }, [_vm._v("\n                    Use ASHE Average\n                ")]) : _vm._e(), _vm._v(" "), (_vm.period.employmentType !== '' && _vm.period.employmentType !== 'absence') ? _c('button', {
    staticClass: "a-button a-button--small u-margin-right-10",
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("\n                    Refine by Occupation\n                ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small u-margin-right-10 u-margin-bottom-10",
    class: {
      'disabled': _vm.postInjuryIncomePeriodPayments.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.addPayment()
      }
    }
  }, [_vm._v("Add Payment Received")])]) : _vm._e(), _vm._v(" "), (_vm.postInjuryIncomePeriodPayments.length && !_vm.toggleOne) ? _c('div', {
    staticClass: "u-d-flex u-flex-item-full u-margin-top-30"
  }, [_c('h2', [_vm._v("Payments Received for Period " + _vm._s(_vm.index + 1))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "5px 0 0 10px"
    },
    on: {
      "click": function($event) {
        return _vm.togglePayments()
      }
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "pre-accident-income",
      "tooltip-text": "To toggle the payments received between visible and hidden just select this icon.",
      "side": "right",
      "text-width": "200",
      "icon-type": "toggle",
      "icon-colour": "m-icon--dark"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.postInjuryIncomePeriodPayments), function(payment, paymentIndex) {
    return (!_vm.toggleOne && !_vm.togglePayment) ? _c('div', {
      staticClass: "u-full-width"
    }, [_c('post-accident-payments', {
      attrs: {
        "periodStart": _vm.period.startOfPeriod,
        "periodEnd": _vm.period.endOfPeriod,
        "payment": payment,
        "paymentIndex": paymentIndex,
        "periodIndex": _vm.index
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.postInjuryIncomePeriodPayments.length && !_vm.toggleOne && !_vm.togglePayment) ? _c('div', {
    staticClass: "u-full-width u-margin-top-10 u-margin-bottom-20"
  }, [_c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.addPayment()
      }
    }
  }, [_vm._v("Add Another Payment")])]) : _vm._e(), _vm._v(" "), (_vm.postInjuryIncomePeriodPayments.length && !_vm.toggleOne && !_vm.togglePayment) ? _c('div', {
    staticClass: "flex-grid__item--third",
    class: {
      'u-padding-l-0': !_vm.toggleOne && !_vm.togglePayment
    }
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Total Payments Received\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true,
      "icon-space": false,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.totalPaymentsReceived
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third",
    class: {
      'u-padding-l-0': !_vm.postInjuryIncomePeriodPayments.length && !_vm.toggleOne || !_vm.toggleOne && _vm.togglePayment
    }
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Total Net Loss\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true,
      "icon-space": false,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.totalNetLoss),
      expression: "period.totalNetLoss"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.period.totalNetLoss)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.period, "totalNetLoss", $event.target.value)
      }
    }
  })])], 1)], 2)]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'ons_salary_' + this.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('div', {
    staticClass: "p-day-one__refine-occupation"
  }, [_c('h2', [_vm._v("Refine by occupation")]), _vm._v(" "), (_vm.selectedNode) ? _c('div', [_c('p', [_vm._v("\n                    Your current selection - "), _c('strong', [_vm._v(_vm._s(_vm.getLastNode().description))]), _c('br'), _vm._v(" "), (_vm.getLastNode().code.length !== 3) ? _c('span', [_vm._v("Select a salary, expand down further or use the average salary for this whole group")]) : _c('span', [_vm._v("Select a salary or use the average salary for this whole group")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.unselectNode(_vm.selectedNode)
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.selectSalary(_vm.selectedNode)
      }
    }
  }, [_vm._v("Use average " + _vm._s(_vm.displaySalary(_vm.selectedNode)))])]) : _c('div', [_c('p', [_vm._v("\n                    Select a salary or expand the group\n                ")])]), _vm._v(" "), _c('div', [_c('div', [_c('table', {
    staticClass: "a-table__small a-table a-table--full-width"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Code")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Salary")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('tbody', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "a-loader--table"
  })])]) : _c('tbody', _vm._l((_vm.nodes), function(node) {
    return _c('tr', {
      staticClass: "selected--row"
    }, [_c('td', [_vm._v(_vm._s(node.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(node.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displaySalary(node)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "a-button a-button--small",
      attrs: {
        "disabled": node.code.length === 4
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectNode(node)
        }
      }
    }, [_vm._v("\n                                    Expand\n                                ")])]), _vm._v(" "), _c('td', [(node.salary !== 'x') ? _c('button', {
      staticClass: "a-button a-button--small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectSalary(node, _vm.type)
        }
      }
    }, [_vm._v("\n                                    Select\n                                ")]) : _vm._e()])])
  }), 0)])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-226662a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/past-loss-of-earnings/PostAccidentEarnings.vue
// module id = 1609
// module chunks = 0